var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShape1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 26,
    viewBox: "0 0 69 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_23)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.681 26.0002L30.8747 18.0509L23.4788 25.5836L16.2197 18.1984L9.10595 25.4447L0 16.1764L2.87286 13.2692L9.10595 19.613L16.2197 12.3666L23.4788 19.7518L30.8747 12.2191L38.681 20.1684L46.7524 11.9414L54.5587 19.8907L60.9286 13.408L63.8015 16.3152L54.5587 25.7224L46.7524 17.7732L38.681 26.0002Z",
    fill: "#F2BC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69 7.87984L61.2535 0L53.8662 7.52403L46.6071 0.138852L39.4848 7.38518L33.2602 1.04139L30.3874 3.9486L39.4848 13.217L46.6071 5.97063L53.8662 13.3558L61.2535 5.83178L69 13.7116V7.87984Z",
    fill: "#F2BC00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_23"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 69,
    height: 26,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape1);
export default __webpack_public_path__ + "static/media/shape-1.cf8e661fa5d9fec224f6c61853d4bde6.svg";
export { ForwardRef as ReactComponent };